import { personPreference } from "../local-storage/personPreference";
import type { PanelWidthChoice } from "./panelPlacement";

export const panelWidthPreference = personPreference<PanelWidthChoice>(
  "assistant-panel-width",
  ["wide", "compact"],
  "wide",
);

export const panelOpenPreference = personPreference<"open" | "closed">("assistant-panel-open", ["open", "closed"], "closed");
